import React from 'react'
import useEventsManager from './use-events-manager'
import { useWillPipe } from '@morningtrain/react-helpers'

export default function TriggerEventOnPipe ({ name }) {
  const manager = useEventsManager()

  useWillPipe((p) => {
    return new Promise((resolve, reject) => {
      manager.trigger(name)
        .then(() => {
          resolve(p)
        })
        .catch(reject)
    })
  }, [manager, name])

  return null
}
